var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg94(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 18.97,
    cy: 35.93,
    r: 6.77
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 36.26,
    cy: 35.93,
    r: 6.77
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.44,13.45l6.15,5.94c0,0,0.18,6.1,4.89,9.58c0,0,1.67-0.2,1.18-1.61c0,0-3.56-3.23-3.69-7.46l17.83,0.03 c0,0,1.02-0.03,0.87-1.46L28.7,5.22c0,0,14,0.33,16.51,12.61l-13.5-0.03c0,0-1.87,1,0.03,2.25l13.48-0.05c0,0-0.31,4.02-3.77,7.38 c0,0-0.33,1.9,1.43,1.59c0,0,5.89-3.87,4.13-13.53c0,0-2-8.61-13.38-11.68c0,0-3.64-0.87-6.15-0.87c0,0-1.23,0.15-0.97,1.69 l-0.2,13.38L9.29,17.9l-6.05-6.02C3.24,11.88,1.44,11.14,1.44,13.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg94);
export default __webpack_public_path__ + "static/media/94.a55a8b7c9032dbe6f70dad93c4bee583.svg";
export { ForwardRef as ReactComponent };